{
  "en": {
    "clearanceRecovery": {
      "recoverInformation": "Recover information",
      "submissionError": "Failed to submit the clearance recovery request",
      "submissionSuccess": "Clearance analysis started. The clearance table will be updated automatically.",
      "completionError": "Clearance analysis failed. Please try again.",
      "noDocumentsSelected": "Please select at least one document",
      "tooManyDocuments": "Please select at most {max} documents"
    }
  },
  "fr": {
    "clearanceRecovery": {
      "recoverInformation": "Récupération des informations",
      "submissionError": "Échec de l'envoi de la requête de récupération des dégagements",
      "submissionSuccess": "Analyse des dégagements lancée. Le tableau des dégagements sera mis à jour automatiquement.",
      "completionError": "L'analyse des dégagements a échoué. Veuillez réessayer.",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document",
      "tooManyDocuments": "Veuillez sélectionner au maximum {max} documents"
    }
  },
  "nl": {
    "clearanceRecovery": {
      "recoverInformation": "Informatie ophalen",
      "submissionError": "Fout bij het indienen van het verzoek om de uitgangen op te halen",
      "submissionSuccess": "Analyse van de uitgangen gestart. De uitgangentabel wordt automatisch bijgewerkt.",
      "completionError": "Analyse van de uitgangen mislukt. Probeer het opnieuw.",
      "noDocumentsSelected": "Selecteer ten minste één document",
      "tooManyDocuments": "Selecteer maximaal {max} documenten"
    }
  }
}
